<template>
  <div class="item-order">
    <PcbItem :bg="false" @click="handleSelect('pcs')" :checked="modal.type === 'pcs'">
      <span>Single PCB</span>
    </PcbItem>
    <Dropdown :popup-max-height="500" @popup-visible-change="handlePopupVisibleChange">
      <PcbItem :bg="modal.type === 'set'?false:true" @click="handleSelect('set')" :checked="modal.type === 'set'">
        <span>Panel PCB As Design           <svg
            xmlns="http://www.w3.org/2000/svg"
            width="8"
            height="7"
            viewBox="0 0 8 7"
            fill="none"
          >
            <path
              d="M4.40544 5.9382C4.20587 6.21473 3.79413 6.21473 3.59456 5.9382L0.241885 1.2926C0.00323535 0.961921 0.239523 0.5 0.647327 0.5L7.35267 0.500001C7.76048 0.500001 7.99676 0.961922 7.75812 1.2926L4.40544 5.9382Z"
              fill="#0060FF"
            />
          </svg></span>
      </PcbItem>
      <template #content>
        <div style="width: 700px;">
          <pcbForm :bg="true" :option="option.set" v-model="modal.set">
            <template #PanelizationMethod>
              <div style="display: flex;align-items: center;justify-content: center;">
                <InputNumber :hide-button="true" v-model="modal.set.pinban_x" append="X" style="width: 150px;" />
                <InputNumber :hide-button="true"  v-model="modal.set.pinban_y" style="width: 140px;" />
              </div>
            </template>
          </pcbForm>
        </div>
      </template>
    </Dropdown>
    <Dropdown :popup-max-height="500" @popup-visible-change="handlePopupVisibleChange">
      <PcbItem :bg="modal.type === 'jpset'?false:true" @click="handleSelect('jpset')" :checked="modal.type === 'jpset'">
        <span>Panel By Aivon           <svg
            xmlns="http://www.w3.org/2000/svg"
            width="8"
            height="7"
            viewBox="0 0 8 7"
            fill="none"
          >
            <path
              d="M4.40544 5.9382C4.20587 6.21473 3.79413 6.21473 3.59456 5.9382L0.241885 1.2926C0.00323535 0.961921 0.239523 0.5 0.647327 0.5L7.35267 0.500001C7.76048 0.500001 7.99676 0.961922 7.75812 1.2926L4.40544 5.9382Z"
              fill="#0060FF"
            />
          </svg></span>
      </PcbItem>
      <template #content>
        <div style="width: 1100px; display: flex;" >
          <pcbForm :option="option.jpset" v-model="modal.jpset">
            <template #Groove>
              <div style="display: flex;align-items: center;justify-content: center">
                <InputNumber :hide-button="true" v-model="modal.jpset.cao_x" prepend="Horizontal" :min="0" append="mm" />
                <InputNumber :hide-button="true" v-model="modal.jpset.cao_y" prepend="Vertical" :min="0" append="mm" />
              </div>
            </template>
            <template #PanelizationMethod>
              <div style="display: flex;align-items: center;justify-content: center;">
                <InputNumber :hide-button="true"v-model="modal.jpset.pinban_x" append="X" style="width: 150px;" />
                <InputNumber :hide-button="true" v-model="modal.jpset.pinban_y" style="width: 140px;" />
              </div>
            </template>
          </pcbForm>
          <div style="width: 600px;margin:15px 20px; position: relative;">
            <p style="color:#7B5822;font-size: 12px;">* Panelization Detail </p>
            <div class="jp-set-box">
              Aivon will fabarciate with total qty of<span style="color:#FF9900;margin: 0 0 0 5px;font-weight: bold;">{{ modal.jpset.pinban_x*modal.jpset.pinban_y*Num }}</span>  pcs
            </div>
            <p style="color:#999;font-size: 12px;">Image for panelized board ↓ (for reference only) <span style="color:#7B5822;">Scaling{{ displaySize.Proportion }}±1°</span></p>
            <div :style="{
                  width:wh.width+'px',
                  minHeight:'100px'
                }">
              <!--       {
        field: "processeEdge_x",
        label: "Edge Rail",
        type: "checkbox",
        dicData: [
          { label: "None", value: "none" },
          { label: "Up and Down Side", value: "updown" },
          { label: "Left and Right Side", value: "leftright" },
          { label: "Round", value: "both" },
        ],
      }, -->
              <div class="measurement-container">
                <div  class="line"></div>
                <div class="value">{{ (BoardWidth*modal.jpset.pinban_y).toFixed(2) }} mm</div>
                <div class="line"></div>
              </div>
              <div class="measurement-container measurement-container__right">
                <div class="line"></div>
                <div class="value">{{ (BoardHeight*modal.jpset.pinban_x).toFixed(2) }} <span style="transform: rotate(190deg);">mm</span></div>
                <div class="line"></div>
              </div>
             <div :style="`height:${displayHeight}px;`">
               <div  style="margin: 10px 0px; display: flex; flex-wrap: wrap; align-content: flex-start;" class="processeEdge_x" :class="'processeEdge_x_'+modal.jpset.processeEdge_x">
                <PcbGridLayout 
                v-show="BoardWidth&&BoardWidth"
                 :width="BoardWidth*modal.jpset.pinban_y"   
                 :height="BoardHeight*modal.jpset.pinban_x"  
                 :edge-type="modal.jpset.processeEdge_x"      
                 :x="modal.jpset.pinban_y"      
                 :y="modal.jpset.pinban_x"     
                 :max-display-width="100"  
                 v-model="wh"
/>
              </div>
            </div>
          </div>

          </div>
        </div>
      </template>
    </Dropdown>
  </div>
</template>
<script setup>
import { Dropdown, InputNumber } from "@arco-design/web-vue";
import PcbItem from "../pcb-item.vue"
import  pcbForm  from "../pcb-form.vue";
import { ref,unref,onMounted,watch,computed,nextTick } from "vue";
import PcbGridLayout from "./order-img.vue"
const emits=defineEmits(["change"])
const modalData=defineModel({
  default:()=>({
    type:'pcs',
    option:{},
  })
})
const wh=ref({
    width:100,
    height:100,
})
// 同步标志，防止死循环
let isSyncing = false;

// 监听 modalData 变化，同步到 modal
watch(modalData, (newVal) => {
  if (isSyncing) return; // 防止死循环
  
  if (newVal && typeof newVal === 'object') {
    isSyncing = true;
    try {
      // 更新 modal 的 type
      if (newVal.type && newVal.type !== modal.value.type) {
        modal.value.type = newVal.type;
      }
      
      // 更新对应类型的 option 数据
      if (newVal.option && typeof newVal.option === 'object') {
        const targetType = newVal.type || modal.value.type;
        if (modal.value[targetType]) {
          // 深度合并，保持响应式
          Object.assign(modal.value[targetType], newVal.option);
        }
      }
    } finally {
      // 使用 nextTick 确保更新完成后再解除锁定
      nextTick(() => {
        isSyncing = false;
      });
    }
  }
}, {
  deep: true,
  immediate: false
})
// 计算显示尺寸，保持比例并限制最大值
const displaySize = computed(() => {
  const totalWidth = BoardWidth.value * modal.value.jpset.pinban_y;
  const totalHeight = BoardHeight.value * modal.value.jpset.pinban_x;
  
  // 边界检查
  if (!totalWidth || !totalHeight || totalWidth <= 0 || totalHeight <= 0) {
    return { width: 100, height: 100 };
  }
  
  // 最大限制
  const maxWidth = 200;
  const maxHeight = 100;
  
  // 计算比例
  const ratio = totalWidth / totalHeight;
  
  let displayWidth, displayHeight;
  
  if (ratio > 1) {
    // 宽度大于高度的情况，以宽度为基准
    displayWidth = maxWidth;
    displayHeight = maxWidth / ratio;
    
    // 如果计算出的高度超过最大高度，以高度为基准重新计算
    if (displayHeight > maxHeight) {
      displayHeight = maxHeight;
      displayWidth = maxHeight * ratio;
    }
  } else {
    // 高度大于等于宽度的情况，以高度为基准
    displayHeight = maxHeight;
    displayWidth = maxHeight * ratio;
    
    // 如果计算出的宽度超过最大宽度，以宽度为基准重新计算
    if (displayWidth > maxWidth) {
      displayWidth = maxWidth;
      displayHeight = maxWidth / ratio;
    }
  }
  const py=modal.value.jpset.pinban_y
  const px=modal.value.jpset.pinban_x
  let itemWidth,itemHeight,Proportion
  if (totalWidth > totalHeight) {
				 Proportion = parseFloat(100 / totalWidth).toFixed(2);
				 itemWidth = 100 / py;
				 itemHeight = totalHeight * Proportion / px;
			} else {
				 Proportion = parseFloat(100 / totalHeight).toFixed(2);
				 itemHeight = 100 / px;
				 itemWidth = totalWidth * Proportion / py;
			}
  return {
    width: Math.round(itemWidth),
    height: Math.round(itemHeight),
    Proportion: Proportion
  };
})

// 为了向后兼容，保留width计算属性
const width = computed(() => displaySize.value.width)
const displayHeight = computed(() => displaySize.value.height)

// 初始化默认值
const props=defineProps({
  field:{
    type:String,
    default:"",
  }
})
const form=defineModel("form")
const BoardHeight=computed(()=>{
  return Number(form.value?.BoardHeight) || 0
})
const BoardWidth=computed(()=>{
  return Number(form.value?.BoardWidth) || 0
})
const Num=computed(()=>{
  return Number(form.value?.Num) || 0
})
if(form?.value && props.field && (form.value[props.field]===undefined || form.value[props.field]===null)){
  form.value[props.field]=modalData.value
}
defineOptions({
  name: "item-order",
  inheritAttrs:false
});
const modal = ref({
  type: "pcs",
  pcs: {},
  set: {
  AcceptCrossed:1,
  VCut:"vcut",
  pinban_x:1,
  pinban_y:1,
  },
  jpset: {
AcceptCrossed:1,
VCut:"vcut",
cao_x:0,
cao_y:0,
pinban_x:1,
pinban_y:1,
processeEdge_x:"none",
processeEdge_y:0
  },
});
watch(modal,()=>{
      option.value.jpset.columns[0].dicData[1].show=modal.value.jpset.pinban_y*modal.value.jpset.pinban_x>=2
      option.value.set.columns[0].dicData[1].show=modal.value.set.pinban_x*modal.value.set.pinban_y>=2
},{
  deep:true,
})
onMounted(()=>{
  if(form?.value && props.field && (form.value[props.field]===undefined || form.value[props.field]===null)){
    modalData.value={
      type:modal.value.type,
      option:modal.value[modal.value.type]
    }
  }
})
watch(modal,()=>{
  if (isSyncing) return; // 防止死循环
  
  modalData.value={
    type:modal.value.type,
    option:modal.value[modal.value.type]
  }
  emits("change",modalData.value)
},{
  deep:true,
})
// 下拉改变触发
function handlePopupVisibleChange(visible) {
  if(visible===false){
    modalData.value={
      type:modal.value.type,
      option:modal.value[modal.value.type]
    }
    emits("change",unref(modalData))
  }
}
function handleSelect(item) {
  modal.value.type = item;
  handlePopupVisibleChange(false)
}
const option = ref({
  set: {
    labelWidth: "160px",
    menu: false,
    columns: [
      {
        field: "AcceptCrossed",
        label: "X-out Panel",
        type: "radio",
        helpIconText:'If you do not accept the X-out Allowance in Panel, the cost will increase accordingly',
        dicData: [
          { label: "Yes", value: 1 },
          { label: "No", value: 0,show:false },
        ],
      },
      {
        field: "PanelizationMethod",
        label: "Panelization Method",
        type: "input",
        helpIconText:'Please input the vertical and horizontal PCB quantity in the panel',
        placeholder: "1 X 1",
      },
      {
        field: "VCut",
        label: "Panel Cutting",
        type: "radio",
        isColor:false,
        helpIconText:'The separating way in the panel PCB. For PCB size is smaller than 75*75mm, we advise selecting tab-routing',
        dicData: [
        { label: "None", value: "none" },
          { label: "V-Scoring", value: "vcut" },
          { label: "Tab-Routing", value: "luocao" },
          {
            label: "V-Scoring+Tab-Routing",
            value: "vcutluocao",
          },
        ],
      },
    ],
  },
  jpset: {
    labelWidth: "160px",
    menu: false,
    columns: [
      {
        field: "AcceptCrossed",
        label: "X-out Panel",
        helpIconText:'If you do not accept the X-out Allowance in Panel, the cost will increase accordingly',
        type: "radio",
        dicData: [
          { label: "Yes", value: 1 },
          { label: "No", value: 0,show:false },
        ],
      },
      {
        field: "PanelizationMethod",
        label: "Panelization Method",
        helpIconText:'Please input the vertical and horizontal PCB quantity in the panel',
      },
      {
        field: "processeEdge_x",
        label: "Edge Rail",
        type: "radio",
        helpIconText:'Edge rail is at the edge of boards to fix the boards on a machine more easily. You can cut the rails easily after assembly',
        isColor:false,
        dicData: [
          { label: "None", value: "none" },
          { label: "Up and Down Side", value: "updown" },
          { label: "Left and Right Side", value: "leftright" },
          { label: "Round", value: "both" },

        ],
        onChange: (value, events) => {
            if(value !== "none"){
              modal.value.jpset.processeEdge_y=modal.value.jpset.processeEdge_y>=4?modal.value.jpset.processeEdge_y:4
            }
            else{
              modal.value.jpset.processeEdge_y=0
            }
          }
      },
      {
        field: "processeEdge_y",
        label: "Edge-Rail Width",
        type: "number",
        min: 4,
        max:100,
        append: "mm",
        helpIconText:'The width of edge rail, normally starts with 4mm',
        span: 12,
        placeholder: "0 mm, min 4mm",
      },
      {
        field: "processeEdge_y_text",
        hideLabel:true,
        label: "Edge-Rail Width",
        type: "div",
        content: "<span>*min 4mm</span>",
        span: 12,
      },
      {
        field: "VCut",
        label: "Panel Cutting",
        type: "radio",
        onChange: (value, events) => {
          events.setColumn("Groove", "display", value === "vcutluocao"||value === "luocao" ? true : false)
          if(value === "vcutluocao"){{
            layer?.msg('If the tab-routings in horizontal or vertical direction needs to be 0, the other is a number between 2-10.')
          }
          }
          // modal.value.jpset.Horizontal = value === "label_vscoringtabrouting" ? '' : modal.value.jpset.Horizontal
          // modal.value.jpset.Vertical = value === "label_vscoringtabrouting" ? '' : modal.value.jpset.Vertical
        },
        isColor:false,
        helpIconText:'The separating way in the panel PCB. For PCB size is smaller than 75*75mm, we advise selecting tab-routing',
        dicData: [
          { label: "None", value: "none" },
          { label: "V-Scoring", value: "vcut" },
          { label: "Tab-Routing", value: "luocao" },
          {
            label: "V-Scoring+Tab-Routing",
            value: "vcutluocao",
          },
        ],
      },
      {
        field: "Groove",
        label: "Groove",
        display:false
      },
    ],
  },
});

</script>
<style scoped>
:deep(.arco-dropdown){
  box-shadow: -2px 0 31px rgba(0,0,0,.1);
}
.box-item{
  width: 10px;
  height: 10px;
  border: 1px solid #dcdcdc;
}
.item-order {
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 10px;
}
.measurement-container {
  width: 100%;
  display: flex;
  align-items: center;
  border-right: 1px solid #dcdcdc;
  border-left: 1px solid #dcdcdc;
  /* border: 1px solid #dcdcdc; */
  justify-content: space-between;
  font-size: 12px;
}

.line {
  width: 8px;
  height: 1px;
  background-color: #dcdcdc;
  border-right: 1px solid #dcdcdc;
}

.value {
  font-size: 12px;
  color: #aaa;
}
:deep(.arco-input-append) {
  background-color: #f5f5f5;
  border-radius: 0px;
  border: none;

}

.processeEdge_x_none{
    /* border-right:1px dashed #ccc; */
    /* border-bottom: 1px dashed #ccc; */
}
.processeEdge_x_updown{
    border-right:1px dashed #ccc;
    border-bottom: 1px dashed #ccc;
}
.processeEdge_x_leftright{
    border-right:1px dashed #ccc;
    border-bottom: 1px dashed #ccc;
}
.processeEdge_x_both{
    border-right:1px dashed #ccc;
    border-bottom: 1px dashed #ccc;
}
  .processeEdge_x::after{
    content: '';
    display: block;
    background-color: transparent;
    margin: 10px 0px;
  }
  .processeEdge_x_both::after{
    border-top: 5px solid black;
    border-bottom: 5px solid black;
    border-left: 5px solid black;
    border-right: 5px solid black;
    width: calc(100% - 10px);
    height: calc(100% - 10px);
  }
  .processeEdge_x_updown::after{
    width:calc(100%);
    height:calc(100% - 5px);
    border-top: 5px solid black;
    border-bottom: 5px solid black;
  }
  .processeEdge_x_leftright::after{
    height:calc(100%);
    border-left: 5px solid black;
    border-right: 5px solid black;
  }
  .measurement-container__right{
    width: 90px;
    bottom:30px;
    position: absolute;
    right:0px;
    transform: rotate(90deg);
  }
  .jp-set-box{
    height: 30px;
    line-height: 28px;
    padding: 0 10px;
    background: #FFF7ED;
    border: 1px solid #0060FF;
    color: #999;
    border-radius: 4px;
  }
</style>
